<script>
    import ProductTypographyToggle from "./ProductTypographyToggle";
    import ProductTypographyVideo from "./ProductTypographyVideo";

    const HEIGHT_TEXT_BLOCK = 300;

    export default {
        name: "ProductTypographyText",
        components: { ProductTypographyVideo, ProductTypographyToggle },
        props: {
            htmlText: String,
            videoList: Array,
        },
        data() {
            return {
                currentHeight: HEIGHT_TEXT_BLOCK,
                anchorElement: null,
            };
        },
        computed: {
            createStyle() {
                return `max-height: ${this.currentHeight}${this.isActiveState ? "px" : "px"}`;
            },
            isActiveState() {
                return this.currentHeight === HEIGHT_TEXT_BLOCK;
            },
        },
        mounted() {
            this.anchorElement = document.querySelector(".js-anchor-description");
        },
        methods: {
            toggled() {
                this.anchorElement.scrollIntoView({ behavior: "smooth" });
                this.currentHeight =
                    this.currentHeight === "8000" ? HEIGHT_TEXT_BLOCK : "8000";
            },
        },
    };
</script>

<template>
    <div class="product-typography-text">
        <div class="product-typography-text__wrapper" :style="createStyle">
            <div class="typography-tags" v-html="htmlText"></div>
            <product-typography-video
                v-if="videoList.length"
                :video-list="videoList"
                :style="{ visibility: isActiveState ? 'hidden' : 'visible' }"
            ></product-typography-video>

            <div v-if="isActiveState" class="gradient-block"></div>
        </div>

        <product-typography-toggle
            :is-active-state="isActiveState"
            text="описание"
            @toggled="toggled"
        ></product-typography-toggle>
    </div>
</template>

<style lang="scss">
    .gradient-block {
        position: absolute;
        z-index: 1;
        left: 0;
        right: 0;
        bottom: 0;
        height: 70px;
        background: var(--product-gradient-block);
    }
    .product-typography-text {
        margin-bottom: 32px;
    }

    .product-typography-text__wrapper {
        position: relative;
        overflow: hidden;
        transition: max-height 0.7s ease-in-out;
    }
</style>
